import styled from 'styled-components';
import { colors, shadows, transitions } from '../../../theme/style-helpers';

export const Card = styled.label`
    padding: 32px;
    background-color: ${colors.LIGHT_GREY};
    display: flex;
    flex-direction: column;
    width: 324px;
    transition: all ${transitions.EASE};
    height: ${(props) => ((props.height) ? props.height : 'fit-content')};

    p {
        margin: 0;
    }

    hr {
        border-top: 1px solid ${colors.GREY_MEDIUM};
    }

    &:hover {
        box-shadow: ${shadows.RAISED};
        transform: translateY(-2px);
        transition: all ${transitions.EASE};
        cursor: pointer;
    }

    &.selected {
        border: 2px solid ${colors.BLACK};
    }

    &.readOnly {
        width: 100%;
        flex-direction: row;

        &:hover {
            box-shadow: none;
            transform: none;
            transition: none;
            cursor: default;
        }
    }
`;

export const Head = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const TitleRow = styled.div`
    display: flex;
    width: 100%;
    gap: 16px;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
    padding: 8px;

    input {
        background-color: ${colors.LIGHT_GREY};
    }

    &.readOnly {
        justify-content: flex-start;
    }
`;

export const InfoRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    flex-wrap: wrap;
`;

export const Body = styled.div`
    flex: 1;
`;

export const CostBreakdown = styled.ul`
    list-style-type: none;
    padding: 4px;
    margin: 0;
`;

export const CostItem = styled.li`
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-bottom: 4px;

    &:last-child {
        padding-bottom: 0;
    }

    p {
        &:first-child {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 70%;
        }
    }
`;

export const RateCardContainer = styled.div`
    display: flex;
    gap: 32px;
    flex-wrap: wrap;

    .capitalize {
        text-transform: capitalize;
    }
`;
